import styled from 'styled-components';

export const Container = styled.div`
  &.carousel-episodes,
  .carousel-episodes {
    &__title {
      margin-bottom: 15px;
    }

    &--want-to-watch {
      .carousel-episodes__title {
        position: relative;
        margin-bottom: -30px;
        margin-right: 80px;
        z-index: 2;
      }
    }
  }
`;

export const CarouselWrapper = styled.div`
  .swiper-slide {
    width: 286px;
  }
`;

export default Container;
